import { colors } from '@lmc/common/constants'
import * as React from 'react'
import IconType from '../../../general/Icon/iconTypes'
import ModuleCard from './ModuleCard'

type Props = {
  onClick?: () => void
}

export const ProModuleCard = ({ onClick }: Props) => (
  <ModuleCard
    backgroundColor={colors.pink}
    icon={IconType.ProHexagon}
    link="/pro-advert"
    linkText="Find out more"
    onClick={onClick}
    subtitle="This is our Pro Plan, deliver person-centred care for all your clients."
    title="NEW Pro!"
  />
)
